import React from "react";
import { useLocation } from "react-router-dom";
import GeneralNav from './General_Nav'
import DashboardNav from './Dashboard_Nav'

const Nav = () => {
  const { pathname } = useLocation();
  const isDashboard = pathname.includes("/dashboard");

  return (
    <>
      {isDashboard ? (
        <DashboardNav />
      ) : (
        <GeneralNav />
      )}
    </>
  );
};

export default Nav;
